export default "__VITE_ASSET__Cg3mVUj2__"